import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TitleStyled = styled(Typography)({
  fontSize: '18px',
  lineHeight: '22px',
  fontWeight: '500',
  marginBottom: '14px',
  marginTop: '24px',
});

export const CardStyled = styled('div')({
  display: 'inline-block',
  background: '#f2f2f2',
  padding: '10px 16px 10px 8px',
  marginRight: '16px',
  position: 'relative',
  borderRadius: '4px',
  fontFamily: 'Montserrat',
  '& .cardText': {
    fontSize: '12px',
    lineHeight: '15px',
    color: '#4E679B',
    fontWeight: 500,
  },
  '& .cardBtn': {
    position: 'absolute',
    top: 0,
    right: 4,
    cursor: 'pointer',
    fontSize: '12px',
    color: '#4E679B',
  },
});
